import $ from 'jquery';
import BaseController from './BaseController';
import {submitErrorMessage} from "@ppcp/utils";

/**
 * Cart Controller
 *
 * Handles WooCommerce cart-specific payment flow orchestration.
 * Works with any payment gateway (PayPal, Google Pay, etc.)
 */
class CartController extends BaseController {

    initialize() {
        this.actions.addAction('cart_updated', this.onCartUpdated.bind(this));
        $(window).on('resize', this.doCartHtml.bind(this));
        $(document).on('change', 'input[name^="shipping_method"]', this.onShippingSelected.bind(this));
        super.initialize();
        this.doCartHtml();
    }

    getElementContainer() {
        return document.getElementById(`wc-${this.id}-cart-button-container`);
    }

    onCartUpdated(data) {
        super.initialize();
        this.doCartHtml();
    }

    /**
     * A single cart update fires both updated_cart_totals and updated_wc_div, so onCartUpdated()
     * runs twice. Without this guard, both renders pass the gateway's shouldCreateElement() check
     * before either one appends its element, which duplicates the payment buttons. A call made
     * while a render is in progress reuses that render instead of starting a second one.
     */
    createPaymentElement() {
        if (!this.paymentElementPromise) {
            this.paymentElementPromise = super.createPaymentElement().finally(() => {
                this.paymentElementPromise = null;
            });
        }
        return this.paymentElementPromise;
    }

    onShippingSelected() {
        this.storeAttributionValues();
    }

    submitError(error) {
        this.hideProcessing();
        submitErrorMessage(error, 'div.woocommerce-notices-wrapper', 'checkout');
    }

    /**
     * Adjust cart payment container width and float to match checkout button
     */
    doCartHtml() {
        const $button = $('.checkout-button');
        const width = $button.outerWidth();
        if (width && $('.wc-ppcp-cart-payments__container').length) {
            $('.wc-ppcp-cart-payments__container').width(width);
        }
        if ($button.css('float') !== 'none') {
            $('.wc-ppcp-cart-payments__container ').css('float', $button.css('float'));
        }
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        $('.wc-ppcp-cart-payments__container').show();
    }

    onPaymentUnavailable() {
        super.onPaymentUnavailable();
        $(`li.payment_method_${this.gateway.id}`).hide();
    }
}

export {CartController};
export default CartController;